export default __webpack_public_path__ + "static/media/Blade's Veil of Arcane Death.ef0b3c4a.jpg";